import { render, staticRenderFns } from "./Wrong.vue?vue&type=template&id=899f6272&"
import script from "./Wrong.vue?vue&type=script&lang=js&"
export * from "./Wrong.vue?vue&type=script&lang=js&"
import style0 from "./Wrong.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports